module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1A8b3yp/tc-custom/9781423623359.jpg?1718072539708",
      "alt": "This image is the cover for the book 200 Casseroles"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("200 Casseroles\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("From the "), _c('i', [_vm._v("New York Times")]), _vm._v("-bestselling author: A wonderfully wide variety of satisfying, super easy one-dish meals!")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" With 200 scrumptious varieties of easy oven, stovetop, and slow cooker casseroles, this collection of recipes will bring the family home for dinner! Here are comfort dishes for meat-and-potato lovers, for finicky kids, and for company alike—there’s something for everyone."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Ideal for kids away at college or busy parents who need to whip together meals quickly, this cookbook offers enough tasty options to keep you satisfied, including: Sausage-Hash Brown Breakfast BakeIncredible Cheeseburger CasseroleBlack Bean Tortilla PieBaked Ravioli AlfredoCorn Bread Chicken-Vegetable Casserole and many more\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Stephanie Ashcraft, Janet Eyring\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Stephanie Ashcraft, author of the original 101 Things To Do With A Cake Mix, has taught cooking classes based on the tips and meals in her cookbooks for almost twenty years. She lives in Tucson, Arizona. Janet Eyring's interest in learning how to cook healthy, inexpensive meals without living in the kitchen inspired her to write a cookbook that relied on the ease of the slow cooker. She also teaches cooking classes at Macey's Little Cooking Theatre. She lives in Highland, UT")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Gibbs Smith\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0